export default __webpack_public_path__ + "static/media/yellowlogo.70b08d1e.png";